var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBasketball = function SvgBasketball(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.929 19.071c3.905 3.905 10.237 3.905 14.142 0 3.905-3.905 3.905-10.237 0-14.142-3.905-3.905-10.237-3.905-14.142 0-3.905 3.905-3.905 10.237 0 14.142ZM7.094 5.68l2.034 2.034a7.95 7.95 0 0 0 1.575-3.609A7.956 7.956 0 0 0 7.094 5.68ZM12 10.586l4.906-4.906a7.965 7.965 0 0 0-4.173-1.647 9.954 9.954 0 0 1-2.182 5.104L12 10.586ZM5.68 7.094l2.034 2.034a7.952 7.952 0 0 1-3.609 1.575A7.956 7.956 0 0 1 5.68 7.094ZM10.586 12 5.68 16.906a7.965 7.965 0 0 1-1.647-4.173 9.954 9.954 0 0 0 5.104-2.182L10.586 12Zm9.38-.733a7.965 7.965 0 0 0-1.646-4.173L13.414 12l1.45 1.45a9.954 9.954 0 0 1 5.103-2.183ZM7.095 18.32a7.965 7.965 0 0 0 4.173 1.647 9.953 9.953 0 0 1 2.182-5.103L12 13.414 7.094 18.32Zm12.8-5.023a7.951 7.951 0 0 0-3.608 1.575l2.034 2.034a7.957 7.957 0 0 0 1.575-3.609Zm-5.022 2.99a7.95 7.95 0 0 0-1.575 3.608 7.957 7.957 0 0 0 3.609-1.575l-2.034-2.034Z",
    fill: "#000"
  })));
};

export default SvgBasketball;